export const translations = {
  nav: {
    home: "首页",
    about: "关于我们",
    services: "服务",
    contact: "联系我们",
    studentPlatform: "学员平台",
    otherProducts: "Other Products"
  },
  hero: {
    title: "AI 驱动的 SaaS 平台研发伙伴",
    subtitle: "我们以可复用的云原生底座和行业大模型经验，帮助成长型企业在 12 周内交付可运营的智能产品。",
    cta: "预约产品咨询"
  },
  features: {
    title: "AI 驱动的 SaaS 能力矩阵",
    items: [
      {
        title: "从 0 到 1 的产品共创",
        description: "策略、设计、工程三方共创，锁定首个可上线版本。",
        longDescription: "我们采用 2 周 Design Sprint + 多轮原型评审，将业务需求映射为清晰的角色、流程与成功指标，确保 AI 能力从一开始就围绕真实商业场景构建。",
        icon: "🧭"
      },
      {
        title: "AI 原生技术底座",
        description: "多模态模型、工作流编排、权限隔离一次集成。",
        longDescription: "平台内置 Prompt/Agent 管理、可观察性、向量检索、FinOps 成本看板与灰度发布流程，可插拔适配 OpenAI、Claude、Azure AI Studio 等主流模型服务。",
        icon: "🤖"
      },
      {
        title: "全托管交付节奏",
        description: "每周可演示成果，12 周看到稳定上线版本。",
        longDescription: "Scrum + 双周里程碑节奏，配套质量门禁、回归脚本、自动化部署与性能基线，确保任何阶段都可演示最新能力并快速回收反馈。",
        icon: "⚙️"
      },
      {
        title: "企业级安全与合规",
        description: "满足数据隔离、审计追踪、合规文档一次生成。",
        longDescription: "参考 SOC2、ISO27001 与国内信创要求构建权限、日志与风控模块，输出安全白皮书、DPA 与可复用的上线合规模板，缩短大客户采购周期。",
        icon: "🛡️"
      }
    ]
  },
  members: {
    title: "核心团队",
    stories: [
      {
        name: "Mersen",
        role: "平台架构负责人",
        quote: "曾在北美与亚太交付 20+ 多租户 SaaS，主导事件驱动架构与可观测性落地，保障平均 2 周一次稳定发布。"
      },
      {
        name: "Alvin",
        role: "AI 产品科学家",
        quote: "负责行业大模型适配与评测体系，建立 Prompt 资产库和人机协同流程，帮助客户把 AI 功能转化为可计量的业务指标。"
      }
    ]
  },
  services: {
    title: "我们的服务组合",
    mostPopular: "CORE",
    getStarted: "预约沟通",
    items: [
      {
        name: "策略与蓝图工作坊",
        features: [
          "AI 产品定位与商业目标梳理",
          "关键角色旅程与痛点映射",
          "可交付模块与数据依赖清单",
          "Lo-Fi 交互稿与优先级路线图"
        ]
      },
      {
        name: "AI SaaS 共创",
        features: [
          "跨职能团队驻场 6-12 周",
          "云原生多租户架构与数据隔离",
          "Prompt / Agent 管理与监控后台",
          "CI/CD + Observability 全链路配置",
          "上线后 30 天性能与体验巡检"
        ]
      },
      {
        name: "平台代运营",
        price: "定制",
        period: "年付",
        features: [
          "SLA ≥ 99.9% 的专业运维与监控",
          "模型版本与提示词持续优化",
          "二线支持、事件响应与回顾",
          "FinOps 成本洞察与调优报告"
        ]
      }
    ]
  },
  faq: {
    title: "常见问题",
    items: [
      {
        question: "如何启动一个合作项目？",
        answer: "预约 30 分钟探索电话，确认业务目标与时间窗口后，我们会在 5 个工作日内提交交付计划与报价。"
      },
      {
        question: "你们擅长哪些行业？",
        answer: "重点覆盖 B2B SaaS、零售、教育、金融合规与数字政务等需要多租户与复杂权限体系的场景。"
      },
      {
        question: "交付节奏如何保证？",
        answer: "以双周里程碑为核心，所有功能通过 Demo Day 与性能基线出具，确保透明可控。"
      },
      {
        question: "我们的数据是否安全？",
        answer: "平台内置数据分级、访问审计和密钥轮转机制，可满足 SOC2、ISO27001 以及中国信创等标准。"
      },
      {
        question: "可以与现有系统集成吗？",
        answer: "我们提供 API / Webhook / iPaaS 方案，并可协助接入 Salesforce、Workday、钉钉、企业微信等生态。"
      }
    ]
  },
  contact: {
    title: "联系我们",
    email: {
      label: "邮箱",
      value: "info@ctrlcv.com"
    },
    wechat: {
      label: "微信",
      qrAlt: "微信二维码"
    },
    xiaohongshu: {
      label: "小红书",
      qrAlt: "小红书二维码"
    }
  },
  footer: {
    copyright: "© 2024 CtrlCV Ltd. 保留所有权利。"
  }
}; 